export default __webpack_public_path__ + "static/image-4-1960f9eda5e6d947c08a173d4836e5bd.jpg";